/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_QuotesInputs */

const en_learn_quotes = /** @type {(inputs: Learn_QuotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[Quotes](/quotes). Quotes on AI risks and governance.`)
};

/**
* | output |
* | --- |
* | "[Quotes](/quotes). Quotes on AI risks and governance." |
*
* @param {Learn_QuotesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const learn_quotes = /** @type {((inputs?: Learn_QuotesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_QuotesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_learn_quotes(inputs)
});